import { Users, KeyRound, Bell, Settings, ClipboardList, Wrench, Undo2 } from "lucide-react";

const TABS = [
  { id: 'users', label: 'Users', icon: Users },
  { id: 'codes', label: 'Access Codes', icon: KeyRound },
  { id: 'notifications', label: 'Notifications', icon: Bell, useBadge: true },
  { id: 'templates', label: 'Templates', icon: ClipboardList },
  { id: 'data-tools', label: 'Data Tools', icon: Wrench },
  { id: 'recovery', label: 'Recovery', icon: Undo2 },
  { id: 'settings', label: 'Settings', icon: Settings },
];

export const TabBar = ({ activeTab, onChange, unreadCount = 0 }) => {
  return (
    <div className="flex items-center gap-2 border-b border-border/50 pb-2 overflow-x-auto">
      {TABS.map(tab => {
        const badge = tab.useBadge ? unreadCount : 0;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-mono text-sm transition-colors relative flex-shrink-0 ${
              activeTab === tab.id
                ? 'bg-primary text-primary-foreground'
                : 'text-foreground bg-muted/40 hover:bg-muted/70'
            }`}
            data-testid={`admin-tab-${tab.id}`}
          >
            <Icon className="w-4 h-4" />
            {tab.label}
            {badge > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
